import { getProjectList, postProject, updateProject, deleteProject } from "@/services/project.service";
import { formatDateEdit, setPaginationDetails } from "../../utils/utils";

// initial state
const state = () => ({
  projectModel: {
    photo: "",
    classTemplateIds: [],
  },
});

// mutations
const mutations = {
  setProjectModel(state, data) {
    state.projectModel = data;
  },
};

// actions
const actions = {
  //Etkinlik Listesi
  async loadProjectList(vuexContext, co) {
    return await getProjectList(co).then((response) => {
      let data = response.data.data;
      let items = data.items;
      let totalCount = data.totalCount;
      let totalPages = data.totalPages;

      items.map((item, index) => {
        item.index = index + 1;
        item.startDate = formatDateEdit(item.startDate);
        item.endDate = formatDateEdit(item.endDate);
        item.active = item.active ? 1 : 0;
        item.coverPhotoPath = item.coverPhoto;
        item.registerLink = process.env.VUE_APP_CDN + "kayit?project=" + item.id;
        item.projectPrice = item.amount + " " + item.currency.isim;
        if (item.coverPhoto) {
          const fetchConfig = {
            mode: "no-cors",
          };
          fetch(process.env.VUE_APP_CDN + "uploads/Project/" + item.coverPhoto, fetchConfig)
            .then((res) => res.blob())
            .then((blob) => {
              item.coverPhoto = new File([blob], "project" + index + ".png", blob);
            });
          item.photo = process.env.VUE_APP_CDN + "uploads/Project/" + item.coverPhoto;
        } else {
          item.photo = "";
        }
      });

      setPaginationDetails(co, totalCount, totalPages);

      return items;
    });
  },

  async postProject(vuexContext, data) {
    return await postProject(data).then((response) => {
      let data = response;
      return data;
    });
  },

  async updateProject(vuexContext, data) {
    return await updateProject(data).then((response) => {
      let data = response;
      return data;
    });
  },

  async deleteProject(vuexContext, data) {
    return await deleteProject(data).then((response) => {
      let data = response;
      return data;
    });
  },

  addProjectModel(vuexContext, data) {
    vuexContext.commit("setProjectModel", data);
  },
};

// getters
const getters = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
